import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 空値データテーブル
 *【結果メッセージ:noResult:string】
 *【説明:description:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-empty-table-data',
  templateUrl: './empty-table-data.html',
  styles: [`
    
  `]
})
export class EmptyTableData extends BaseWidget {
  /**
   * 結果メッセージ
   */
  @Input() noResult:string

  /**
   * 説明
   */
  @Input() description:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/empty-table-data/empty-table-data.component.ts